<template>
  <section class="page">
    <div class="container">
      <h3 class="title02 page__h2">参戦履歴照会</h3>
      <div class="box box--center mb-24">
        <p>{{ message }}</p>
      </div>
      <div class="mb-40">
        <h3 class="title02 page__h2">
            参加種別選択
        </h3>
        <div class="row mb-24">
          <div class="col-6 col-sm-6 col-md-4 mb-2">
            <div class="page__inputGroup d-block flex-wrap">
              <div>
                <button type="button" 
                    :class="['checkbox02__label', 'text-center', 'w-100', 'me-3', 'mb-3', get_entry_type_btn_active('result')]"
                    id="input011" 
                    @click="toggleEntryType"
                >
                競技会エントリー
                </button>
              </div>
            </div>
          </div>
          <div class="col-6 col-sm-6 col-md-4 mb-2">
            <div class="page__inputGroup d-block flex-wrap">
              <div>
                <button type="button" 
                    :class="['checkbox02__label', 'text-center', 'w-100', 'me-3', 'mb-3', get_entry_type_btn_active('yakuin')]"
                    id="input011" 
                    @click="toggleEntryType"
                >
                競技役員
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section v-if="chk_entry_type('result')">
        <div class="mb-40">
          <h3 class="title02 page__h2">
              検索 
          </h3>
          <div class="row gy-24">
            <div class="col-md-4">
              <p class="mb-12">
                <bs-select
                  :options="year_list"
                  :nullOption="false"
                  v-model="result_year"
                ></bs-select> 
              </p>
            </div>
            <div class="col-md-4" v-if="false">
              <p class="mb-12">
                <bs-select
                  :options="year_list"
                  :nullOption="false"
                  v-model="result_year"
                ></bs-select> 
              </p>
            </div>
            <div class="col-md-4">
              <p class="mb-12 py-2">
                <a 
                    class="button04"
                    id="input011" 
                    @click="loadResultObj"
                >
                <span class="button04__text">検索</span>
              </a>
              </p>
            </div>
          </div>   
        </div>
        <div class="mb-40">
          <div class="" v-if="get_result_series_data.length > 0">
            <template v-for="series in get_result_series_data" :key="series.series_cd" class="mb-24">
              <div class="mb-12">
                <h3 class="title04 page__h4">
                    {{ series.label }} 
                </h3>
              </div>
              <div class="mb-12">
                <table class="table table-striped">
                  <thead>
                    <tr style="border-bottom:solid 2px #CCC;">
                      <th><h4 class="title06">競技会名</h4></th>
                      <!-- <th><h4 class="title06">クラス名</h4></th> -->
                      <th><h4 class="title06">順位</h4></th>
                      <th><h4 class="title06">ポイント</h4></th>
                      <th><h4 class="title06">昇格ポイント</h4></th>
                    </tr>
                  </thead>
                  <tbody v-for="class_data in get_result_series_class_data(series.series_cd)" :key="class_data.class_id">
                    <tr style="border-bottom:dashed 2px #CCC;">
                      <th colspan="4">
                        <h4 class="title06" v-html="'▼&nbsp;' + class_data.label"></h4>
                      </th>
                    </tr>
                    <tr v-for="result in get_result_filter_series(series.series_cd, class_data.class_id)" :key="result.mfj_result_id">
                      <!-- <td><span v-html="result.mfj_event_sub_data_event_name"></span></td> -->
                      <td><span v-html="get_result_event_name_heatchk(result)"></span></td>
                      <!-- <td><span v-html="result.mfj_class_data_name"></span></td> -->
                      <td>
                        <span v-if="parseInt(result.mfj_result_rank) && parseInt(result.mfj_result_rank) > 0">{{ result.mfj_result_rank }}</span>
                        <span v-else-if="parseInt(result.mfj_result_rank) == 0">DNF</span>
                        <span v-else-if="result.mfj_result_rank == -90">DNS</span>
                        <span v-else-if="result.mfj_result_rank == -99">失格</span>
                      </td>
                      <td>{{ formatPoint(result.mfj_result_sum_point) }}</td>
                      <td>{{ formatPoint(result.mfj_result_levelup_point) }}</td>
                    </tr>
                    <tr style="border-bottom:solid 2px #CCC;border-top:dashed 2px #CCC;">
                      <th class="force-white" colspan="3" style="text-align: right;">
                        <span v-html="class_data.label + 'の合計&nbsp;▶&nbsp;'"></span>
                      </th>
                      <th class="force-white">{{ formatPoint(get_result_series_sum_point(series.series_cd, class_data.class_id)) }}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
          <div v-else-if="non_first_search_e">
            <div class="box">
              <p>検索を行ってください</p>
            </div>
          </div>
          <div v-else>
            <div class="box">
              <p>履歴データがありません。</p>
            </div>
          </div>
        </div>
      </section>
      <section v-if="chk_entry_type('yakuin')">
        <div class="mb-40">
          <div class="" v-if="yakuin_license_list.length > 0">
            <template v-for="license in yakuin_license_list" :key="license.key" class="mb-24">
              <div class="mb-12">
                <h3 class="title04 page__h4">
                  {{ license.label }}
                </h3>
              </div>
              <div class="mb-12">
                <table class="table table-striped">
                  <thead>
                    <tr style="border-bottom:solid 2px #CCC;">
                      <th><h4 class="title06">年度</h4></th>
                      <th><h4 class="title06">競技会名</h4></th>
                      <th><h4 class="title06">役職</h4></th>
                      <th><h4 class="title06">長/副</h4></th>
                      <th><h4 class="title06">ポイント</h4></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="yakuin in get_yakuin_filter_license(license.key)" :key="yakuin.id">
                      <td>{{ yakuin.license_year }}</td>
                      <td><span v-html="yakuin.mfj_event_sub_data_event_name"></span></td>
                      <td>{{ get_list_label(yakuin.mfj_officer_position, officer_position) }}</td>
                      <td>{{ get_list_label(yakuin.mfj_officer_seihuku_flg, officer_seifuku) }}</td>
                      <td>{{ yakuin.mfj_officer_point }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr style="border-top:solid 2px #CCC;">
                      <th colspan="4" style="text-align: right;">合計</th>
                      <th>{{ formatPoint(get_yakuin_sum_point(license.key)) }}</th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </template>
          </div>
          <div v-else-if="non_first_search_y">
            <div class="box">
              <p>検索中です</p>
            </div>
          </div>
          <div v-else>
            <div class="box">
              <p>履歴データがありません。</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>
<style>
.force-white {
  background-color: #FFF !important;
}
</style>
<script>
import config from '../../../const'
import BsSelect from '../../atoms/BsSelect.vue'
import Common from '../../../common/common'

export default {
  name: 'UserEntryResultView',
  data: function () {
    return {
      targetid: this.$store.state.auth.userId,
      message: '競技会参戦・参加履歴です。競技会エントリーの成績、競技役員業務に従事した履歴と付与された実務ポイントが照会できます。',
      entry_type: 'result', //or yakuin
      result_year: Common.getNowYear(),
      yakuin_year: Common.getNowYear(),

      non_first_search_e: true,
      non_first_search_y: true,

      event_cd_obj: [],
      data_obj: {},
      license_obj: [],
      yakuin_license: [
        {
          key: 'road_race_level_3',
          label: 'ロードレース競技役員3級'
        },
        {
          key: 'road_race_level_2',
          label: 'ロードレース競技役員2級'
        },
        {
          key: 'road_race_level_1',
          label: 'ロードレース競技役員1級'
        },
        {
          key: 'motor_cross_level_3',
          label: 'モトクロス競技役員3級'
        },
        {
          key: 'motor_cross_level_2',
          label: 'モトクロス競技役員2級'
        },
        {
          key: 'motor_cross_level_1',
          label: 'モトクロス競技役員1級'
        },
        {
          key: 'trial_level_3',
          label: 'トライアル競技役員3級'
        },
        {
          key: 'trial_level_2',
          label: 'トライアル競技役員2級'
        },
        {
          key: 'trial_level_1',
          label: 'トライアル競技役員1級'
        },
        {
          key: 'snowmobile_level_3',
          label: 'スノーモビル競技役員3級'
        },
        {
          key: 'snowmobile_level_2',
          label: 'スノーモビル競技役員2級'
        },
        {
          key: 'snowmobile_level_1',
          label: 'スノーモビル競技役員1級'
        },
        {
          key: 'other_level_3',
          label: 'その他競技役員3級'
        },
        {
          key: 'other_level_2',
          label: 'その他競技役員2級'
        },
        {
          key: 'other_level_1',
          label: 'その他競技役員1級'
        },
      ],
      officer_position: [
        {key: 0, label: '審査委員'},
        {key: 1, label: '競技監督'},
        {key: 2, label: '車検'},
        {key: 3, label: '計時'},
        {key: 4, label: '進行'},
        {key: 5, label: '保安'},
        {key: 6, label: '救護'},
        {key: 7, label: '管制'},
        {key: 8, label: '審判'},
        {key: 9, label: 'コース'},
        {key: 10, label: 'セクション審判'},
        {key: 11, label: '事務局'},
      ],
      officer_seifuku: [
        {key: 0, label: ''},
        {key: 1, label: '長'},
        {key: 2, label: '副'},
      ],

      result_obj: [],
      yakuin_obj: []
    }
  },
  components: {
    BsSelect
  },
  methods: {
    async loadYakuinObj(){
      this.result_obj = []
      const params = {}
      params.licenseNo = this.data_obj.license_no
      console.log('params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_yakuin/lists',
        params
      )
        .then(async (response) => {
          console.log('loadResultObj response', response)
          this.yakuin_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.yakuin_obj = []
        })
        .finally(async () => {
          this.non_first_search_y = false
          this.$forceUpdate()
        })
    },
    async loadResultObj(){
      this.result_obj = []
      const params = {}
      params.targetYear = this.result_year
      params.licenseNo = this.data_obj.license_no
      console.log('params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_result/lists',
        params
      )
        .then(async (response) => {
          console.log('loadResultObj response', response)
          this.result_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.result_obj = []
        })
        .finally(async () => {
          this.non_first_search_e = false
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/' + param,
        params
      )
        .then(async (response) => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async toggleEntryType(){
      this.result_obj = []
      this.yakuin_obj = []
      if(this.entry_type == 'result'){
        this.entry_type = 'yakuin'
        await this.loadYakuinObj()
      }else{
        this.entry_type = 'result'
      }
    },
    async loadEventCdObj() {
      const params = {}
      params['stat'] = [1]
      params['id'] = this.$store.state.auth.userId
      await this.basicPosts_S(config.BASE_API_URL + '/member/lists', params)
        .then(async (response) => {
          console.log('loadUserObj', response)
          this.event_cd_obj =
            response.data && response.data.body && response.data.body ?
            response.data.body : []
        })
        .catch(async (err) => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadUserObj() {
      const params = {}
      params['stat'] = [1]
      params['id'] = this.$store.state.auth.userId
      await this.basicPosts_S(config.BASE_API_URL + '/member/lists', params)
        .then(async (response) => {
          console.log('loadUserObj', response)
          this.data_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async (err) => {
          console.log(err)
          this.data_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadUserLicenseObj() {
      const params = {}
      params['stat'] = [1]
      params['license_class'] = 2
      params['m_id'] = this.$store.state.auth.userId
      await this.basicPosts_S(config.BASE_API_URL + '/member_license/lists', params)
        .then(async (response) => {
          console.log('loadUserObj', response)
          this.license_obj =
            response.data && response.data.body 
              ? response.data.body
              : []
        })
        .catch(async (err) => {
          console.log(err)
          this.license_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    formatPoint(value){
      if(!value) return 0;
      return (parseFloat(value) % 1 === 0) ? parseFloat(value).toFixed(0) : parseFloat(value).toString();
    },
  },
  computed: {
    get_list_label: function () {
      return function (key, lists) {
        if (
          typeof lists === 'object' &&
          typeof lists.find((list) => list.key == key) === 'object'
        ) {
          return lists.find((list) => list.key == key).label
        }
        return key
      }
    },
    year_list: function () {
      let min = 2015
      const max = Common.getNowYear()
      const tmps = []
      for (let i = min; i <= max + 1; i++) {
        tmps.push({
          key: i,
          label: i + '年度'
        })
      }
      return tmps
    },
    yakuin_license_list: function(){
      return this.yakuin_license.filter(license => {
        if(Array.isArray(this.yakuin_obj) && this.yakuin_obj.length > 0 && this.yakuin_obj.find(yakuin => yakuin[license.key] && parseInt(yakuin[license.key]) > 0)){
          return true
        }
        return false
      })
    },
    event_cd_list: function(){
      return []
    },
    chk_entry_type: function () {
      const entry_type = this.entry_type
      return function(type){
        if(entry_type == type) return true
        return false
      }
    },
    get_entry_type_btn_active: function () {
      const chk = this.chk_entry_type
      return function(type){
        if(chk(type)){
          return {active : false}
        }
        return {active : true}
      }
    },
    get_result_series_sum_point: function(){
      const get_data = this.get_result_filter_series
      return function(series_cd, class_id){
        let point = 0
        if(Array.isArray(get_data(series_cd, class_id))){
          get_data(series_cd, class_id).map(data => {
            if(parseFloat(data.mfj_result_levelup_point) > 0){
              point += parseFloat(data.mfj_result_levelup_point)
            }
          })
        }
        return point
      }
    },
    get_result_filter_series: function(){
      const results = this.result_obj
      return function(series_cd, class_id){
        if(Array.isArray(results) && results.length > 0){
          return [...results.filter(result => result.race_series_cd == series_cd && result.mfj_class_data_id == class_id)]
        }
        return []
      }
    },
    get_result_event_name_heatchk: function(){
      const obj_list = this.result_obj
      return function(result){
        if(Array.isArray(obj_list) && obj_list.find(obj => obj.mfj_event_main_data_id == result.mfj_event_main_data_id) && obj_list.filter(obj => obj.mfj_event_main_data_id == result.mfj_event_main_data_id).length > 1){
          return result.mfj_event_sub_data_event_name + ' heat ' + result.mfj_result_heat
        }
        return result.mfj_event_sub_data_event_name
      }
    },
    get_result_series_class_data: function(){
      // const series_data = this.get_result_series_data
      const results = this.result_obj
      return function (series_cd) {
        const tmps = []
        if(Array.isArray(results) && results.length > 0){
          results.map(result => {
            if(
              result.race_series_cd == series_cd && 
              !tmps.find(tmp => tmp.class_id == result.mfj_class_data_id)
            ){
              tmps.push({
                class_id: result.mfj_class_data_id,
                label: result.mfj_class_data_name
              })
            }
          })
        }
        return tmps
      }
    },
    get_result_series_data: function(){
      const tmps = []
      if(Array.isArray(this.result_obj) && this.result_obj.length > 0){
        this.result_obj.map(result => {
          if(
            !tmps.find(tmp => tmp.series_cd == result.race_series_cd)
          ){
            tmps.push({
              series_cd: result.race_series_cd,
              label: result.race_series_name
            })
          }
        })
      }
      return tmps
    },
    get_yakuin_sum_point: function(){
      const get_data = this.get_yakuin_filter_license
      return function(column){
        let point = 0
        if(Array.isArray(get_data(column))){
          get_data(column).map(data => {
            if(parseFloat(data.mfj_officer_point) > 0){
              point += parseFloat(data.mfj_officer_point)
            }
          })
        }
        return point
      }
    },
    get_yakuin_filter_license: function(){
      const yakuin_data = this.yakuin_obj
      return function(column){
        return yakuin_data.filter(yakuin => {
          if(
            yakuin[column] && parseInt(yakuin[column]) > 0
          ){
            console.log('column', column, yakuin[column], yakuin)
            return true
          }
          return false
        })
      }
    },
  },
  async created() {
    await this.loadUserObj()
    // await this.setUserObj()
  },
  mounted: function () {
  },
  props: {},
}
</script>
